import API from '../../services/api';


// api.js

export const fetchUsers = async ({
  search = '',
  page = 1,
  limit = 10,
  role = null,
  status = null,
  branch = null,
  sortField = null,
  sortOrder = null,
}) => {
  try {
    const params = {
      page,
      limit,
    };

    if (search && search.trim() !== '') {
      params.search = search.trim();
    }

    if (role) {
      params.role = role;
    }

    if (status) {
      params.status = status;
    }

    if (branch) {
      params.branch = branch;
    }

    if (sortField) {
      params.sortField = sortField;
    }

    if (sortOrder) {
      params.sortOrder = sortOrder;
    }

    const response = await API.get('/users', { params });
    
    console.log('[Users API] Request params:', params);
    console.log('[Users API] Response:', response.data);

    return response.data; // expecting { data: [...], meta: {...} }
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};


export const registerUser = async (userData) => {
  try {
    // userData should include role, branch, region, modules
    const response = await API.post('users/register', userData);
    return response.data; // expecting { message: 'User created', user: {...} }
  } catch (error) {
    console.error('Error registering user:', error);
    throw error;
  }
};

//Delete User by id
export const deleteUser = async (userId) => {
  try{
    const response = await API.delete(`/users/${userId}`)
    return response.data;
  } catch(error){
    console.error('Error Deleting User', error);
    throw error;
  }
};


// Fetch user by ID
export const fetchUserById = async (userId) => {
  try {
    const response = await API.get(`/users/${userId}`);
    return response.data; // expecting user object
  } catch (error) {
    console.error('Error fetching user:', error);
    throw error;
  }
};

// Update user by ID
export const updateUserById = async (userId, updateData) => {
  try {
    // updateData should include role, branch, region, modules if changed
    const response = await API.put(`/users/${userId}`, updateData);
    return response.data; // expecting { message: 'User updated', user: {...} }
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};


export const fetchUsersForRoleMapping = async () => {
  try {
    const response = await API.get('/approval/users');
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

// Roles now live in src/services/rolesApi.js (GET /roles) and are consumed through
// the useRoles hook / RoleSelect component, so every role dropdown shares one
// source and one shape.

// Fetch all branches with search and pagination support
export const fetchBranches = async ({ search = '', page = 1, limit = 10 }) => {
  try {
    const response = await API.get('/branches', {
      params: {
        search,
        page,
        limit
      },
    });
    return response.data;  // Return the response data
  } catch (error) {
    console.error('Error fetching branches:', error);
    throw error;
  }
};